import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps';
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from "./router"
import store from "./store"
import '@/directives/DynamicModel'
import '@/directives/Convert'
// @ts-ignore
import VueSanitize from 'vue-sanitize';
import SarSymbol from '@/components/CSarSymbol.vue'

Vue.component('SarSymbol', SarSymbol)
Vue.config.productionTip = false

Vue.use(VueSanitize)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places', // necessary for places input
  },
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
